/**
 * compliance_frameworks.risk_level arrives in two casings, and will keep doing
 * so.
 *
 * The column is documented lowercase ("critical", "high", "medium", "low") and
 * that is what the rows carry. But the GRC discovery path asks a model for
 * `"risk_level": "Critical|High|Medium|Low"` (routers/grc.py), so anything it
 * writes comes back capitalised, and nothing between there and the database
 * validates it. There is no single producer to fix.
 *
 * So readers are made tolerant instead of the data being migrated: compare on
 * the normalised value, show the label. Writers emit the documented lowercase.
 */

export const RISK_LEVELS = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
  { value: 'critical', label: 'Critical' },
];

/** The canonical lowercase value, or '' when unset or unrecognised. */
export function normalizeRiskLevel(value) {
  const key = (value || '').toString().trim().toLowerCase();
  return RISK_LEVELS.some((l) => l.value === key) ? key : '';
}

/**
 * How to show it. Falls back to the raw value rather than hiding it: a level
 * this does not recognise is still something somebody wrote, and showing it
 * is how it gets noticed and corrected.
 */
export function riskLevelLabel(value) {
  const key = normalizeRiskLevel(value);
  if (!key) return (value || '').toString();
  return RISK_LEVELS.find((l) => l.value === key).label;
}
